module.exports = __webpack_public_path__ + "static/media/image4.0b37f434.jpg";